import React from 'react'

import {
  BarChart,
  AreaChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ComposedChart,
  Area
} from 'recharts'
import {orderAmount} from '../share/order_helper'
import {toDate} from '../share/date_helper'
import ChartTooltipContent from './ChartTooltipContent'
import TimeRangeFilter from './TimeRangeFilter'

export default class OrderStatistics extends React.Component {
  constructor(props){
    super(props)
    const startDate = new Date()
    startDate.setDate(1)
    startDate.setMonth(startDate.getMonth()-1)
    const endDate = new Date()
    this.state = {startDate, endDate}
  }

  render(){
    let orders = this.props.orders.filter(order => {
      const date = new Date(toDate(order.date))
      const startDate = new Date(this.state.startDate)
      const endDate = new Date(this.state.endDate)
      date.setHours(0,0,0,0)
      startDate.setHours(0,0,0,0);
      endDate.setHours(0,0,0,0);
      
      return date >= startDate && date <= endDate
    })

    orders.sort((a, b) => a.date.seconds - b.date.seconds)


    const groupedData = {}

    let totalRevenue = 0
    let totalCount = 0
    orders.forEach(order => {
      const date = toDate(order.date)
      const key = `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`

      groupedData[key] = groupedData[key] || {
        date: order.date, name: key, revenue: 0, count: 0, totalRevenue: 0
      }
      const amount = orderAmount(order)
      totalRevenue += amount.totalGross
      totalCount += 1
      groupedData[key].revenue += amount.totalGross
      groupedData[key].count += 1
      groupedData[key].totalRevenue = totalRevenue
      groupedData[key].totalCount = totalCount
    })

    const data = Object.values(groupedData)
    data.forEach(datum => {
      datum.revenue=Number(datum.revenue.toFixed(2))
      datum.totalRevenue=Number(datum.totalRevenue.toFixed(2))
    })

    // data.sort((a, b) => a.date.seconds - b.date.seconds)

    return (
      <React.Fragment>
        <div className="card">
          <TimeRangeFilter 
            startDate={this.state.startDate} 
            endDate={this.state.endDate}
            onChange={(startDate,endDate) => this.setState({startDate,endDate})}/>
        </div>
        <div className="portlet">
          <div className="portlet-heading">
            <h3 className="portlet-title text-dark"> Umsatz </h3>
            <div className="clearfix"/>
          </div>
          <div className="panel-collapse collapse show">
            <div className="portlet-body">
              <ComposedChart
                width={824} height={400} data={data}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey="name" stroke="#888888" strokeWidth={0}/>
                <YAxis stroke="#888888" strokeWidth={0}/>
                <Tooltip content={<ChartTooltipContent/>} />
                <Legend verticalAlign="top"/>
                <Bar dataKey="count" name="Anzahl der Aufträge" fill="#80deea" />
                <Bar dataKey="revenue" name="Umsatz" fill="#3bafda" />
              </ComposedChart>
            </div>
          </div>
        </div>

        <div className="portlet">
          <div className="portlet-heading">
            <h3 className="portlet-title text-dark"> Umsatz akkumuliert</h3>
            <div className="clearfix"/>
          </div>
          <div className="panel-collapse collapse show">
            <div className="portlet-body">
              <ComposedChart
                width={824} height={400} data={data}
                margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                <XAxis dataKey="name" stroke="#888888" strokeWidth={0}/>
                <YAxis stroke="#888888" strokeWidth={0}/>
                <Tooltip content={<ChartTooltipContent/>} />
                <Legend verticalAlign="top"/>
                <Area
                  type="monotone"
                  dataKey="totalRevenue"
                  fill="rgba(59,175,218,0.8)"
                  stroke="#3bafda"
                  name="Umsatz"/>
                <Area
                  type="monotone"
                  dataKey="totalCount"
                  fill="rgba(0,180,156,0.8)"
                  stroke="#00b19d"
                  name="Anzahl der Aufträge"/>
              </ComposedChart>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/components/OrderStatistics.js